module.exports = __webpack_public_path__ + "static/media/alerta-combustible-rojo.193cdbc3.svg";